/* MERIDIO — script del tema (vanilla, senza librerie) */
(function () {
  'use strict';

  /* Il file è incluso da più sezioni: esegui una sola volta */
  if (window.__mdScriptsLoaded) return;
  window.__mdScriptsLoaded = true;

  /* Animazioni di entrata allo scroll */
  function initReveals() {
    var els = document.querySelectorAll('.md-reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('md-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('md-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Galleria della pagina prodotto */
  function initGalleria() {
    document.querySelectorAll('[data-md-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('.md-prodotto__gallery-main img');
      var thumbs = gallery.querySelectorAll('.md-prodotto__thumb');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-md-src');
          if (!src) return;
          main.src = src;
          main.srcset = '';
          thumbs.forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* Galleria scorrevole per variante (pagina MURALE) */
  function initGalleriaVarianti() {
    document.querySelectorAll('[data-md-galleria]').forEach(function (g) {
      var binario = g.querySelector('[data-md-galleria-binario]');
      var slides = Array.prototype.slice.call(g.querySelectorAll('.md-galleria__slide'));
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('.md-galleria__thumb'));
      var prec = g.querySelector('[data-md-galleria-prec]');
      var succ = g.querySelector('[data-md-galleria-succ]');
      var contatore = g.querySelector('[data-md-galleria-contatore]');
      if (!binario || !slides.length) return;

      function visibili() { return slides.filter(function (s) { return !s.hidden; }); }
      function attuale() { return Math.round(binario.scrollLeft / Math.max(binario.clientWidth, 1)); }

      function segna() {
        var v = visibili();
        var i = Math.min(attuale(), v.length - 1);
        var slide = v[i];
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', slides[k] === slide ? 'true' : 'false'); });
        if (contatore) contatore.textContent = v.length > 1 ? (i + 1) + ' / ' + v.length : '';
        if (prec) prec.disabled = i <= 0;
        if (succ) succ.disabled = i >= v.length - 1;
      }

      function vai(i, liscio) {
        var v = visibili();
        if (!v.length) return;
        i = Math.max(0, Math.min(i, v.length - 1));
        binario.scrollTo({ left: v[i].offsetLeft, behavior: liscio ? 'smooth' : 'auto' });
      }

      var attesa;
      binario.addEventListener('scroll', function () {
        clearTimeout(attesa);
        attesa = setTimeout(segna, 60);
      }, { passive: true });
      if (prec) prec.addEventListener('click', function () { vai(attuale() - 1, true); });
      if (succ) succ.addEventListener('click', function () { vai(attuale() + 1, true); });
      binario.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); vai(attuale() - 1, true); }
        if (e.key === 'ArrowRight') { e.preventDefault(); vai(attuale() + 1, true); }
      });
      thumbs.forEach(function (t, k) {
        t.addEventListener('click', function () { vai(visibili().indexOf(slides[k]), true); });
      });

      // Cambio variante (menu o bundle): restano solo le sue foto e quelle comuni
      document.addEventListener('md:variante', function (e) {
        if (!e.detail) return;
        var id = String(e.detail.id);
        slides.forEach(function (s, k) {
          var per = s.getAttribute('data-md-per');
          var nascosta = !!per && per !== id;
          s.hidden = nascosta;
          if (thumbs[k]) thumbs[k].hidden = nascosta;
        });
        vai(0, false);
        segna();
      });

      segna();
    });
  }

  /* Selettore varianti della pagina prodotto */
  function initVarianti() {
    document.querySelectorAll('[data-md-variants]').forEach(function (wrap) {
      var jsonEl = wrap.querySelector('[data-md-variants-json]');
      var section = wrap.closest('.md-prodotto');
      if (!jsonEl || !section) return;
      var variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var selects = wrap.querySelectorAll('select[data-md-option]');
      // Sulla scheda ci possono essere due form (acquisto e pagamento rapido):
      // il campo della variante va aggiornato in tutti, non solo nel primo.
      var idInputs = section.querySelectorAll('[data-md-variant-id]');
      var idInput = idInputs[0];
      var addBtn = section.querySelector('[data-md-add]');
      var priceBox = section.querySelector('[data-md-price]');

      function aggiorna() {
        var scelte = Array.prototype.map.call(selects, function (s) { return s.value; });
        var trovata = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === scelte[i]; });
        });
        if (!trovata) return;
        idInputs.forEach(function (el) { el.value = trovata.id; });
        // Foto principale: segue la variante se la variante ha una sua foto
        if (trovata.img) {
          var principale = section.querySelector('.md-prodotto__gallery-main img');
          if (principale) principale.src = trovata.img;
        }
        // Avvisa il bundle (e chiunque altro ascolti) che la variante è cambiata
        document.dispatchEvent(new CustomEvent('md:variante', { detail: { id: trovata.id } }));
        if (addBtn) {
          addBtn.disabled = !trovata.available;
          addBtn.textContent = trovata.available ? (addBtn.dataset.mdLabel || addBtn.textContent) : 'ESAURITO';
          if (trovata.available && !addBtn.dataset.mdLabel) addBtn.dataset.mdLabel = addBtn.textContent;
        }
        if (priceBox) {
          var now = priceBox.querySelector('.md-prodotto__price-now');
          var was = priceBox.querySelector('.md-prodotto__price-was');
          if (now) now.textContent = trovata.price;
          if (was) {
            if (trovata.compare) { was.textContent = trovata.compare; was.style.display = ''; }
            else { was.style.display = 'none'; }
          }
        }
      }
      selects.forEach(function (s) { s.addEventListener('change', aggiorna); });
    });
  }

  /* Strip video clienti: autoplay muto in loop, audio attivabile dal pulsante */
  function initVideoStrip() {
    var cards = document.querySelectorAll('[data-md-videocard]');
    if (!cards.length) return;
    function silenzia(card) {
      var v = card.querySelector('video');
      if (v) v.muted = true;
      card.classList.remove('md-audio-on');
    }
    /* Il file parte solo quando serve: finche la card non arriva sullo schermo
       il video non pesa niente sulla pagina. */
    function aggiungiSorgente(video, url, tipo) {
      if (!url) return;
      var s = document.createElement('source');
      s.src = url;
      s.type = tipo;
      video.appendChild(s);
    }
    /* play() parte un istante prima che la sorgente sia pronta e viene rifiutata:
       in quel caso si riprova appena il video e pronto. */
    function riproduci(video) {
      if (!video) return;
      var p = video.play();
      if (p && p.catch) {
        p.catch(function () {
          video.addEventListener('canplay', function () {
            var q = video.play();
            if (q && q.catch) q.catch(function () {});
          }, { once: true });
        });
      }
    }
    function caricaVideo(video) {
      if (!video || video.getAttribute('data-md-caricato')) return;
      var hls = video.getAttribute('data-md-hls');
      var mp4 = video.getAttribute('data-md-src');
      if (!hls && !mp4) return;
      /* Ordine voluto: chi sa leggere lo stream adattivo lo usa e scarica molto meno,
         gli altri scendono sull'mp4. */
      aggiungiSorgente(video, hls, 'application/x-mpegURL');
      aggiungiSorgente(video, mp4, 'video/mp4');
      aggiungiSorgente(video, video.getAttribute('data-md-riserva'), 'video/mp4');
      video.setAttribute('data-md-caricato', '1');
      video.load();
    }
    cards.forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;
      video.muted = true;
      video.loop = true;
      video.controls = false;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      /* La pecetta col play resta visibile finche il video non parte davvero:
         senza, il primo fotogramma nero sembra un riquadro rotto. */
      video.addEventListener('playing', function () { card.classList.add('md-playing'); });
      video.addEventListener('pause', function () { card.classList.remove('md-playing'); });
      /* Con lo stream adattivo l'attributo loop non viene rispettato: alla fine
         il video resta fermo sull'ultimo fotogramma. Lo facciamo ripartire a mano. */
      video.addEventListener('ended', function () {
        try { video.currentTime = 0; } catch (e) {}
        riproduci(video);
      });
      var btn = card.querySelector('[data-md-audio]');
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (video.muted) {
            /* Un solo video con l'audio alla volta */
            cards.forEach(function (c) { if (c !== card) silenzia(c); });
            video.muted = false;
            card.classList.add('md-audio-on');
            caricaVideo(video);
            riproduci(video);
          } else {
            silenzia(card);
          }
          btn.setAttribute('aria-label', video.muted ? (window.meridioEu?.unmute || "Unmute") : (window.meridioEu?.mute || "Mute"));
        });
      }
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target.querySelector('video');
        if (!v) return;
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-md-visto', '1');
          caricaVideo(v);
          riproduci(v);
        } else if (entry.target.getAttribute('data-md-visto')) {
          /* Si mette in pausa solo cio che e gia stato visto almeno una volta:
             cosi i video avviati in anticipo continuano a girare mentre il
             cliente e ancora in cima alla pagina, e li trova gia in movimento. */
          v.pause();
          /* Fuori dallo schermo si torna in muto: niente audio a sorpresa */
          silenzia(entry.target);
        }
      });
    }, { threshold: 0.25, rootMargin: '1200px 0px' });
    cards.forEach(function (card) { io.observe(card); });

    /* Avvio anticipato. Quanti riquadri partono subito lo decide l'impostazione
       del tema. Partono DOPO che la pagina ha finito di caricare e in un momento
       morto del browser, cosi non rubano banda a testo e immagini: la prima
       schermata resta veloce come prima. Restano dentro il loro riquadro, muti,
       senza schermo intero (playsinline). */
    var strip = document.querySelector('.md-videostrip');
    var quanti = strip ? parseInt(strip.getAttribute('data-md-avvio'), 10) : 0;
    if (isNaN(quanti)) quanti = 0;
    if (quanti > 0) {
      var parti = function () {
        for (var i = 0; i < Math.min(quanti, cards.length); i++) {
          var v = cards[i].querySelector('video');
          if (!v) continue;
          caricaVideo(v);
          riproduci(v);
        }
      };
      var programma = function () {
        if (window.requestIdleCallback) window.requestIdleCallback(parti, { timeout: 2500 });
        else setTimeout(parti, 800);
      };
      if (document.readyState === 'complete') programma();
      else window.addEventListener('load', programma);
    }
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('md-design-mode');
  }

  function initHero3D() {
    var heroes = document.querySelectorAll('.md-hero--3d');
    if (!heroes.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (document.documentElement.classList.contains('md-design-mode')) return;
    heroes.forEach(function (hero) {
      var media = hero.querySelector('.md-hero__media');
      var inner = hero.querySelector('.md-hero__inner');
      if (!media) return;
      var intensita = parseFloat(hero.getAttribute('data-md-3d')) || 5;
      var maxRot = intensita * 0.45;
      var mx = 0, my = 0, raf = null;

      function render() {
        raf = null;
        media.style.transform = 'rotateX(' + (-my * maxRot).toFixed(2) + 'deg) rotateY(' + (mx * maxRot).toFixed(2) + 'deg)';
        if (inner) inner.style.transform = 'translate3d(' + (-mx * intensita * 1.8).toFixed(1) + 'px,' + (-my * intensita * 1.4).toFixed(1) + 'px,0)';
      }
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        mx = ((e.clientX - r.left) / r.width - 0.5) * 2;
        my = ((e.clientY - r.top) / r.height - 0.5) * 2;
        if (!raf) raf = requestAnimationFrame(render);
      });
      hero.addEventListener('mouseleave', function () {
        mx = 0; my = 0;
        if (!raf) raf = requestAnimationFrame(render);
      });

      var ticking = false;
      function parallasse() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var r = hero.getBoundingClientRect();
          if (r.bottom < 0 || r.top > window.innerHeight) return;
          var p = Math.max(-1, Math.min(1, r.top / window.innerHeight));
          media.style.setProperty('--md-par', (-p * intensita * 9).toFixed(1) + 'px');
        });
      }
      window.addEventListener('scroll', parallasse, { passive: true });
      parallasse();
    });
  }

  /* Bracciale in regalo: aggiunge orologio + FUNE al carrello insieme */
  function initRegalo() {
    document.querySelectorAll('[data-md-regalo]').forEach(function (box) {
      var section = box.closest('.md-prodotto');
      if (!section) return;
      var form = section.querySelector('.md-prodotto__form');
      var check = box.querySelector('[data-md-regalo-attivo]');
      var img = box.querySelector('[data-md-regalo-img]');
      if (!form || !check) return;
      function stato() { box.classList.toggle('md-regalo--off', !check.checked); }
      check.addEventListener('change', stato);
      stato();
      box.querySelectorAll('[data-md-regalo-variante]').forEach(function (r) {
        r.addEventListener('change', function () {
          if (img && r.dataset.img) img.src = r.dataset.img;
        });
      });
      form.addEventListener('submit', function (e) {
        var scelto = box.querySelector('[data-md-regalo-variante]:checked');
        var idInput = form.querySelector('[data-md-variant-id]');
        if (!check.checked || !scelto || !idInput) return;
        e.preventDefault();
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [
            { id: parseInt(idInput.value, 10), quantity: 1 },
            { id: parseInt(scelto.value, 10), quantity: 1 }
          ] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/cart';
        }).catch(function () {
          HTMLFormElement.prototype.submit.call(form);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initGalleria();
    initGalleriaVarianti();
    initVarianti();
    initVideoStrip();
    initHero3D();
    initRegalo();
  });
})();
